module.exports = __webpack_public_path__ + "media/images/pc/specials/common/benefits_campaign-0d0ced03c0083c667c39e1a392a4e18a.png";